import { PayrollClient } from './payroll-client';
export default function PayrollPage() { return <PayrollClient />; }
